import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH

export default {

  categoryGetList(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/getList',
      type: 'get',
      params: params
    })
  }, 
  categoryAddUpd(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/addUpd',
      type: 'post',
      params: params,
      qs:false
    })
  },
  categoryDel(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/del',
      type: 'post',
      params: params,
    })
  },
  categoryDetail(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/detail',
      type: 'get',
      params: params
    })
  },
  categoryUpdStatus(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/updStatus',
      type: 'post',
      params: params,
    })
  },
  categorySort(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal-category/sort',
      type: 'post',
      params: params,
    })
  },
  proposalGetList(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal/getList',
      type: 'get',
      params: params
    })
  },
  proposalDetail(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal/detail',
      type: 'get',
      params: params
    })
  },
  proposalVerify(data) {
    const params = data
    return request({
      url: urlParams + '/activity-proposal/verify',
      type: 'post',
      params: params,
      qs:false
    })
  },
}